export default {
  zh: {
    title: `亲爱的用户:`,
    txt1: `
    为了回馈您对App的支持，我们将每月举办一次充值活动。当您充值时，我们会给您额外30%的硬币。
    `,
  },
  en: {
    title: `Dear users:`,
    txt1: `In order to give back your support for App, we will hold a recharge activity every month. When you recharge, we will give you an additional 30% coins.`,
  },
  ar: {
    title: ` عزيزي المستخدم: `,
    txt1: ` من أجل سداد دعمك لـ App ، سنعقد حدث إعادة شحن من 26 إلى 29 من كل شهر.عند الشحن ، سنمنحك ذهبية إضافية بنسبة 30٪. `,
  },
  uz: {
    title: 'Hurmatli foydalanuvchilar:',
    txt1: "Ilovaga qo'llab-quvvatlaganingiz uchun minnatdorchilik sifatida har oyda yuklash faoliyati o'tkazamiz. Yuklash qilganingizda, biz sizga qo'shimcha 30% tanga beramiz.",
  },
  ru: {
    title: 'Уважаемые пользователи:',
    txt1: 'В целях благодарности за вашу поддержку приложения, мы будем проводить акцию пополнения каждый месяц. При пополнении мы дадим вам дополнительные 30% монет.',
  },
  fa: {
    title: 'کاربران عزیز:',
    txt1: 'به منظور قدردانی از حمایت شما از برنامه، هر ماه یک فعالیت شارژ برگزار خواهیم کرد. هنگام شارژ، ما به شما ۳۰٪ سکه اضافی خواهیم داد.',
  },
  pt: {
    title: 'Prezados usuários:',
    txt1: 'Para retribuir o seu apoio ao aplicativo, realizaremos uma atividade de recarga todo mês. Quando você recarregar, nós lhe daremos 30% de moedas adicionais.',
  },
  id: {
    title: 'Pengguna yang terhormat:',
    txt1: 'Untuk memberikan dukungan atas aplikasi ini, kami akan mengadakan aktivitas pengisian ulang setiap bulan. Ketika Anda mengisi ulang, kami akan memberi Anda tambahan 30% koin.',
  },

  ur: {
    title: `پیارے صارفین:`,
    txt1: `ایپ کی حمایت کے بدلے میں، ہم ہر ماہ ایک ریچارج سرگرمی کا انعقاد کریں گے۔ جب آپ ریچارج کریں گے، ہم آپ کو اضافی 30% سکے دیں گے۔`,
  },
}



// WEBPACK FOOTER //
// src/pages/app/rechargebonus/lang.js